api = require '../api'

module.exports =

    fetch: (q) ->
        api.send
          method: 'GET'
          path: "/api/v2/dam/search?q=" + encodeURIComponent(q)
